import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAuth, RedirectIfAuthed } from './guards';
import { LandingPage } from '@/features/landing/LandingPage';
import { AuthPage } from '@/features/auth/AuthPage';
import { OAuthCallbackPage } from '@/features/auth/OAuthCallbackPage';
import { OnboardingPage } from '@/features/onboarding/OnboardingPage';
import { AppLayout } from './AppLayout';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { EditorPage } from '@/features/editor/EditorPage';
import { TemplatesPage } from '@/features/templates/TemplatesPage';
import { AnalyticsPage } from '@/features/analytics/AnalyticsPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { ComingSoonPage } from '@/features/shared/ComingSoonPage';
import { NotFoundPage } from '@/features/shared/NotFoundPage';
import { PublicPortfolioPage } from '@/features/public/PublicPortfolioPage';
import { publicHostFromLocation } from '@/lib/config';

// When the browser is on a tenant subdomain (e.g. alice.portfilo.online) or a
// custom domain pointed at us, every path should render the published portfolio.
// The builder app routes only exist on the app origin (app.portfilo.online / dev).
const publicHostRouter = createBrowserRouter([
  { path: '*', element: <PublicPortfolioPage /> },
]);

const appRouter = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/auth/oauth-complete', element: <OAuthCallbackPage /> },
  { path: '/p/:subdomain', element: <PublicPortfolioPage /> },
  {
    element: <RedirectIfAuthed />,
    children: [{ path: '/sign-in', element: <AuthPage /> }],
  },
  {
    element: <RequireAuth />,
    children: [
      { path: '/onboarding', element: <OnboardingPage /> },
      {
        path: '/app',
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'editor', element: <EditorPage /> },
          { path: 'templates', element: <TemplatesPage /> },
          { path: 'analytics', element: <AnalyticsPage /> },
          { path: 'domains', element: <ComingSoonPage title="Domains" /> },
          { path: 'settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <Navigate to="/404" replace /> },
]);

export const router = publicHostFromLocation() ? publicHostRouter : appRouter;
